import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

const StyledVoiceListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  padding: ${({ isLeaderboard }) => (isLeaderboard ? '8px 16px' : '8px')};
  border-radius: 12px;
  background-color: ${(props) =>
    props.isActive ? COLOR.backgroundActiveVoice : COLOR.white};
  background-color: ${({ isLeaderboard }) => isLeaderboard && 'transparent'};
  height: 64px;
  max-height: 64px;
  width: 100%;
  box-sizing: border-box;
  box-shadow: ${({ isLeaderboard }) =>
    isLeaderboard ? '0px 4px 16px 0px #00000014' : 'none'};
  @media only screen and (max-width: 1296px) and (min-width: 768px) {
    gap: 16px;
  }
  border: 1px solid
    ${(props) => (props.isActive ? COLOR.borderActiveVoice : 'transparent')};

  ${(props) =>
    props.isAudioPlaying &&
    `
      animation: backgroundTransition 2s ease-in-out infinite alternate;
      border: 1px solid ${COLOR.indigo.default};
      box-sizing: border-box;
    `}

  &:hover {
    border-radius: 12px;
    background-color: ${(props) =>
      props.isAudioPlaying ? 'none' : COLOR.secondary[40]};
    background-color: ${(props) =>
      props.isActive ? COLOR.backgroundActiveVoice : COLOR.secondary[40]};
    cursor: pointer;
  }

  @keyframes backgroundTransition {
    0% {
      background-color: #ebebed;
    }
    25% {
      background-color: #e5e5e8;
    }
    50% {
      background-color: #e7e7ea;
    }
    75% {
      background-color: #e0e0e4;
    }
    100% {
      background-color: #f4f4f5;
    }
  }
`;

const StyledVoiceInfoContainer = styled.div`
  flex: 1;
  max-width: 324px;
  min-width: ${({ isLeaderboard }) => (isLeaderboard ? '356px' : '324px')};
  box-sizing: border-box;
  @media screen and (max-width: 840px) {
    min-width: 250px;
  }
`;

const StyledVoiceLanguageContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 0px 8px;
  max-width: 170px;
  flex: 1;
  box-sizing: border-box;
  display: ${({ parentWidth }) => (parentWidth <= 844 ? 'none' : 'flex')};
`;

const StyledVoiceMetadataContainer = styled.div`
  display: ${({ parentWidth, isVoiceAboutToBeRemoved }) =>
    parentWidth <= 990 && !isVoiceAboutToBeRemoved ? 'none' : 'flex'};
  align-items: center;
  gap: 8px;
  padding: 12px 8px;
  flex: 1;

  .metadata-item {
    width: 73px;
  }
`;

const StyledVoiceActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const StyledVoiceListItemInfoContainer = styled.div`
  display: flex;
  gap: ${({ parentWidth }) => (parentWidth <= 840 ? '8px' : '32px')};
  flex: 1;
  @media screen and (max-width: 840px) {
    max-width: 360px;
  }
`;

export {
  StyledVoiceListItem,
  StyledVoiceMetadataContainer,
  StyledVoiceActionContainer,
  StyledVoiceInfoContainer,
  StyledVoiceLanguageContainer,
  StyledVoiceListItemInfoContainer,
};
